import { useState } from "react";
import { MdChevronRight } from "react-icons/md";

import giaoduc from "../../assets/images/giaoduc.webp";
import ite from "../../assets/images/ite.webp";
import xuhuong_giaoduc from "../../assets/images/xuhuong_giaoduc.webp";
import cdsyte from "../../assets/images/cdsyte.webp";
import trungtam_daotao from "../../assets/images/trungtam_daotao.webp";
import qlgd from "../../assets/images/qlgd.webp";
import udcdsyte from "../../assets/images/udcdsyte.webp";

export default function TabComponent() {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 2; // Total number of pages (adjust dynamically based on the eventData)
  const [activeTab1, setActiveTab1] = useState("Tin mới nhất");

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const renderPageNumbers = () => {
    let pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - 1 && i <= currentPage + 1)
      ) {
        pageNumbers.push(
          <button
            key={i}
            onClick={() => handlePageClick(i)}
            className={`px-3 py-1 rounded-lg ${
              i === currentPage
                ? "bg-blue-100 text-blue-500 font-semibold"
                : "text-gray-700"
            }`}
          >
            {i}
          </button>
        );
      } else if (i === currentPage - 2 || i === currentPage + 2) {
        pageNumbers.push(
          <span key={i} className="px-2 text-gray-500">
            ...
          </span>
        );
      }
    }
    return pageNumbers;
  };

  const eventData = [
    {
      image: giaoduc,
      title: "Giải pháp chuyển đổi số giáo dục",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      link: "/new-detail",
    },
    {
      image: ite,
      title:
        "Giải Pháp Phần Mềm Y Tế: Ứng Dụng Công Nghệ trong Chăm Sóc Sức Khỏe",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      link: "/new-detail/phanmem-yte",
    },
    {
      image: xuhuong_giaoduc,
      title: "Chuyển Đổi Số Trong Giáo Dục: Xu Hướng Tất Yếu Của Thời Đại",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      link: "/new-detail/xuhuong-giaoduc",
    },
    {
      image: cdsyte,
      title:
        "Chuyển Đổi Số Trong Y Tế: Tương Lai Của Hệ Thống Chăm Sóc Sức Khỏe",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      link: "/new-detail/chuyendoiso-yte",
    },
    {
      image: trungtam_daotao,
      title: "Phần Mềm Quản Trị Trung Tâm Đào Tạo: Tối Ưu Hóa Quản Lý",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      link: "/new-detail/quantri-daotao",
    },
    {
      image: qlgd,
      title: "Giải Pháp Phần Mềm Quản Lý Giáo Dục: Tăng Hiệu Quả",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      link: "/new-detail/qlgd",
    },
    {
      image: udcdsyte,
      title: "Ứng Dụng Chuyển Đổi Số Trong Y Tế: Tăng Cường Chăm Sóc",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      link: "/new-detail/udcdsyte",
    },
  ];

  // Calculate events to display on the current page
  const eventsPerPage = 6;
  const startIndex = (currentPage - 1) * eventsPerPage;
  const endIndex = startIndex + eventsPerPage;
  const currentEvents = eventData.slice(startIndex, endIndex);

  // Update totalPages based on the eventData length
  const updatedTotalPages = Math.ceil(eventData.length / eventsPerPage);

  const renderContent = () => {
    switch (activeTab1) {
      case "Tin mới nhất":
        return (
          <div className="grid grid-cols-3 gap-5">
            {/* Render dynamic content for each event */}
            {currentEvents.map((event, index) => (
              <div
                key={index}
                className="shadow-custom max-w-full relative rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]"
              >
                <div>
                  <img
                    src={event.image} // Use dynamic image for each event
                    alt={event.title}
                    className="w-full h-auto rounded-t-[20px]"
                  />
                </div>
                <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] relative h-[15rem] ">
                  <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute -top-4 left-2 z-10 flex items-center justify-center">
                    <p className="text-[16px] font-normal text-white">
                      Tin tức
                    </p>
                  </div>
                  <p className="text-[24px] font-semibold text-[#0C5393]">
                    {event.title}
                  </p>
                  <a href={event.link}>
                    <div className="flex items-center absolute bottom-2 gap-2 text-[16px] font-normal text-[#1C9BDB] hover:text-blue-800">
                      <p>Xem chi tiết</p>
                      <MdChevronRight />
                    </div>
                  </a>
                </div>
              </div>
            ))}
          </div>
        );
      case "Tin tức":
        return <p>Content for Tin tức - Trang {currentPage}</p>;
      case "Sự kiện":
        return <p>Content for Sự kiện - Trang {currentPage}</p>;
      default:
        return null;
    }
  };

  return (
    <div className="w-full p-3">
      <div className="h-[59px] rounded-[40px] bg-white shadow-custom border border-solid border-gray-200 flex items-center gap-6 px-3">
        {["Tin mới nhất", "Tin tức", "Sự kiện"].map((tab) => (
          <div
            key={tab}
            onClick={() => setActiveTab1(tab)}
            className={`cursor-pointer ${
              activeTab1 === tab
                ? "text-blue-500 font-semibold"
                : "text-gray-700"
            }`}
          >
            <p>{tab}</p>
          </div>
        ))}
      </div>

      <div className="mt-4 p-4">{renderContent()}</div>

      <div className="flex items-center justify-between space-x-4 mt-4">
        <button
          onClick={handlePrevious}
          disabled={currentPage === 1}
          className="px-4 py-2 border rounded-lg text-gray-500 hover:bg-gray-100 disabled:opacity-50"
        >
          ← Trước
        </button>
        <div className="flex items-center space-x-1">{renderPageNumbers()}</div>
        <button
          onClick={handleNext}
          disabled={currentPage === updatedTotalPages}
          className="px-4 py-2 border rounded-lg text-gray-500 hover:bg-gray-100 disabled:opacity-50"
        >
          Tiếp →
        </button>
      </div>
    </div>
  );
}
